import { Component, inject } from '@angular/core';
import { MatCalendar } from '@angular/material/datepicker';
import { DateAdapter } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-calendar-header',
  imports: [
    MatIconModule
  ],
  template: `
    <div class="calendar-header">
      <button mat-icon-button (click)="prevClicked()">
        <mat-icon>chevron_left</mat-icon>
      </button>

      <div class="header-label">
        {{ monthLabel }} {{ yearLabel }}
      </div>

      <button mat-icon-button (click)="nextClicked()">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  `,
  styleUrls: ['./calendar-header.component.scss'],
})
export class CalendarHeaderComponent {

  calendar = inject(MatCalendar);
  adapter = inject(DateAdapter);

  get monthLabel() {
    return this.adapter.getMonthNames('long')[this.calendar.activeDate.getMonth()];
  }

  get yearLabel() {
    return this.calendar.activeDate.getFullYear();
  }

  prevClicked() {
    this.calendar.activeDate = this.adapter.addCalendarMonths(this.calendar.activeDate, -1);
  }

  nextClicked() {
    this.calendar.activeDate = this.adapter.addCalendarMonths(this.calendar.activeDate, 1);
  }
}
